// Pure helpers for the "Map Surfaces" step.
// mappings: { [lineId]: { surfaceId: string|null, accepted: boolean } }

export const SECTION_LABELS = {
  wall: "Walls",
  ceiling: "Ceilings",
  door: "Doors & Frames",
  trim: "Trim & Rails",
  misc: "Miscellaneous",
  exterior: "Exterior",
};

/** Parse result → initial mappings (suggestions pre-filled, nothing accepted yet). */
export const initMappings = (lines) =>
  Object.fromEntries(lines.map((l) => [l.id, { surfaceId: l.suggestedSurfaceId || null, accepted: false }]));

/** "Accepted" | "Suggested" | "Unmapped" | "Skipped" */
export const getStatus = (mapping, skipUnmapped) => {
  if (mapping?.surfaceId) return mapping.accepted ? "Accepted" : "Suggested";
  return skipUnmapped ? "Skipped" : "Unmapped";
};

/** SF Qty preview — same conversion the engine uses (unknown unit → surface unit). */
export const sfQtyFor = (line, surface) => {
  if (!surface || !(line.qty > 0)) return null;
  const unit = line.unit || surface.unit;
  return unit === "SF" ? line.qty : line.qty * surface.sfPerUnit;
};

export const mappingStats = (lines, mappings) => {
  const mapped = lines.filter((l) => mappings[l.id]?.surfaceId).length;
  return {
    total: lines.length,
    mapped,
    unmapped: lines.length - mapped,
    low: lines.filter((l) => l.confidence === "Low").length,
    warnings: lines.filter((l) => l.warnings.length > 0).length,
    pendingHigh: lines.filter((l) => l.confidence === "High" && mappings[l.id]?.surfaceId && !mappings[l.id]?.accepted).length,
  };
};

export const FILTERS = {
  ALL: () => true,
  UNMAPPED: (l, m) => !m[l.id]?.surfaceId,
  LOW: (l) => l.confidence === "Low",
  WARNINGS: (l) => l.warnings.length > 0,
};

/** Lines grouped by raw section, keeping file order. */
export const groupBySection = (lines) => {
  const groups = [];
  const byKey = {};
  lines.forEach((l) => {
    if (!byKey[l.section]) {
      byKey[l.section] = { section: l.section, label: SECTION_LABELS[l.section] || l.section, lines: [] };
      groups.push(byKey[l.section]);
    }
    byKey[l.section].lines.push(l);
  });
  return groups;
};
